<template>
  <div class="constructor_scroll">
    <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
      <div class="tittle">
        <div class="breadcrumbs">
          <router-link to="/partners">{{textContent.title}}</router-link>
          <span></span>
          <h1>{{copyItem.title}}</h1>
        </div>
      </div>
      <div class="edit_main">
        <div class="folder radius" v-if="isLoaded">
          <div class="column caption">
            <p>Редактирование партнера</p>
          </div>
          <div class="column">
            <div class="content">
              <new-input title="Заголовок" name="title"></new-input>
              <new-input title="Ссылка" name="url"></new-input>
              <edit-file class="short align-top" use-case="cover" v-if="isLoaded" title="Изображение"
                         name="img"></edit-file>
              <new-input title="Alt" name="seo_alt"></new-input>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="save" @click="onSubmit">{{textContent.saveButton}}</button>
          <button class="cancel" @click="reset">{{textContent.cancelButton}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IconUpload from '@/components/icons/IconUpload'
  import NewTextArea from '@/components/edit-form/new-items/TextArea'
  import NewInput from '@/components/edit-form/new-items/Input'
  import OldInput from '@/components/edit-form/old-items/Input'
  import OldTextArea from '@/components/edit-form/old-items/TextArea'
  import OldEditor from '@/components/edit-form/old-items/Editor'
  import EditDropDown from '@/components/edit-form/DropDown'
  import EditFile from '@/components/edit-form/File'
  import Checkbox from '@/components/edit-form/Checkbox'
  import {createNamespacedHelpers} from 'vuex'
  import Calendar from '../../../edit-form/Calendar'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('editPage')

  export default {
    data () {
      return {
        isLoaded: false,
        editorInstance: '',
        text: '',
        editor: null,
      }
    },
    computed: {
      ...mapState([
        'item',
        'copyItem',
        'textContent'
      ]),
      apiUrls () {
        return this.$store.state.apiUrls
      },
      parentId() {
        return this.$store.state.parentId
      }
    },
    methods: {
      ...mapActions([
        'init',
        'edit',
        'reset'
      ]),
      ...mapMutations([
        'resetModule',
        'setFileExtensions',
        'setItemField'
      ]),
      onSubmit () {
        this.edit({
          title: this.item.title,
          img: this.item.img,
          seo_alt: this.item.seo_alt,
          url: this.item.url
        })
      }
    },
    mounted () {
    },
    created () {
      this.resetModule()
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.init({
        textContent: {
          title: 'Партнеры',
          cancelButton: 'Отмена',
          saveButton: 'Сохранить',
          greeting: 'Все изменения успешно сохранены',
          subtitle: 'Редактирование цитаты',
          seo: 'SEO информация',
          options: 'Прочие настройки',
        },
        errors: {
          title: {message: 'Введите заголовок цитаты', hasError: false},
          url: {message: 'Введите ссылку', hasError: false},
          img: {message: 'Допустимые расширения: jpg, jpeg, png, gif', hasError: false},
          seo_alt: {isNullable:true, hasError: false}
        },
        itemId: this.$route.params.id,
        apiUrl: this.apiUrls.content
      }).then(() => {
        this.isLoaded = true
      })
    },
    components: {
      Calendar,
      NewTextArea,
      NewInput,
      OldInput,
      OldTextArea,
      OldEditor,
      EditDropDown,
      EditFile,
      IconUpload,
      Checkbox
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/partners/pages/Edit.vue